module.exports = __webpack_public_path__ + "static/media/phone-green.97d72a97.svg";